import ChartMakeDrawPage from './ChartMakeDrawPage';

export default ChartMakeDrawPage;
